/* riccava: In den Warenkorb per AJAX, Drawer schiebt sich ein (Dawn cart-drawer). Fehler (z. B. ausverkauft) werden am Button gezeigt; nur bei Netzfehler normales Absenden. */
(function(){
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  function drawer(){return document.querySelector('cart-drawer')}
  function busy(el,on){if(!el)return;el.classList.toggle('is-busy',on);if(on)el.setAttribute('aria-busy','true');else el.removeAttribute('aria-busy')}
  function note(el,msg){
    if(!el)return; var host=el.closest('form')||el.parentNode; if(!host)return;
    var n=host.querySelector('.rc-cart-note'); if(!n){n=document.createElement('p');n.className='rc-cart-note';n.setAttribute('role','alert');host.appendChild(n)}
    n.textContent=msg; clearTimeout(n._t); n._t=setTimeout(function(){n.remove()},5000);
  }
  function post(fd){
    var d=drawer();
    if(d&&typeof d.getSectionsToRender==='function'){fd.append('sections',d.getSectionsToRender().map(function(s){return s.id}).join(','));fd.append('sections_url',location.pathname)}
    return fetch(root+'cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'},body:fd})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,json:j}})});
  }
  function show(res){
    var d=drawer();
    try{
      if(d&&typeof d.renderContents==='function'&&res.sections){d.renderContents(res);d.classList.remove('is-empty');var di=d.querySelector('.drawer__inner');if(di)di.classList.remove('is-empty')}
      else{location.href=root+'cart';return}
    }catch(e){try{sessionStorage.setItem('rc-cart-err',String(e&&e.message)+' | '+String(e&&e.stack).slice(0,300))}catch(x){}location.href=root+'cart';return}
    document.dispatchEvent(new CustomEvent('rc:cart:added',{detail:res}));
  }
  function handle(p,btn,fallback){
    busy(btn,true);
    p.then(function(r){
      if(!r.ok||(r.json&&r.json.status)){note(btn,(r.json&&(r.json.description||r.json.message))||'Fehler');return}
      show(r.json);
      if(btn&&btn.hasAttribute('data-rc-add')){btn.classList.add('is-added');setTimeout(function(){btn.classList.remove('is-added')},2200)}
    }).catch(function(e){try{sessionStorage.setItem('rc-cart-err','net: '+String(e&&e.message))}catch(x){}if(fallback)fallback()}).then(function(){busy(btn,false)});
  }
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f||f.tagName!=='FORM')return;
    if(((f.getAttribute('action')||'')).indexOf('/cart/add')<0)return;
    if(f.closest('product-form'))return;
    if(e.defaultPrevented)return; /* z. B. Mengenlimit prueft erst und sendet dann erneut */
    e.preventDefault();
    var btn=e.submitter||f.querySelector('[type=submit]');
    handle(post(new FormData(f)),btn,function(){HTMLFormElement.prototype.submit.call(f)});
  },true);
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-rc-add]'); if(!b)return;
    e.preventDefault(); e.stopPropagation();
    if(b.classList.contains('is-busy'))return;
    var fd=new FormData(); fd.append('id',b.getAttribute('data-rc-add')); fd.append('quantity','1');
    handle(post(fd),b,function(){location.href=root+'cart/add?id='+b.getAttribute('data-rc-add')+'&quantity=1'});
  },true);
})();
